import * as namesConfiguracion from './nombres/configuracion'
import * as namesInformes from './nombres/informes'
import * as namesMantenimiento from './nombres/mantenimiento'
import * as namesTransacciones from './nombres/transacciones'
import { buildBreadcrumb } from '@/@core/utils/router'
import permisosPersona, { RESOURCE_PERSONA } from '@/auth/permissions/modules/personaPg'
import { defineRoutes } from '@/utils/router'

const { mantenimiento, configuracion, transacciones, informes } = permisosPersona

export default defineRoutes([
    /**
     * RUTAS DE MANTENIMIENTO
     */
    {
        path: '/persona-pg/mantenimiento/entidades',
        name: namesMantenimiento.ROUTE_ENTIDADES,
        component: () => import('@pages/persona-pg/mantenimiento/Entidades.vue'),
        meta: {
            title: 'i18n:persona.subopciones.entidades',
            resource: RESOURCE_PERSONA,
            action: mantenimiento.entidades,
            breadcrumb: buildBreadcrumb(
                'a:persona.menu_title',
                'a:global.menu.mantenimiento',
                'persona.subopciones.entidades'
            ),
        },
    },
    {
        path: '/persona-pg/mantenimiento/entidad/:entidadId?',
        name: namesMantenimiento.ROUTE_REGISTRAR_ENTIDAD,
        component: () => import('@/views/pages/persona-pg/mantenimiento/entidad/RegistrarEntidad.vue'),
        meta: {
            title: 'i18n:persona.subopciones.registro_entidad',
            resource: RESOURCE_PERSONA,
            action: mantenimiento.registrarEntidad,
            breadcrumb: buildBreadcrumb(
                'a:persona.menu_title',
                'a:global.menu.mantenimiento',
                'persona.subopciones.entidades',
                'persona.subopciones.registro_entidad'
            ),
        },
    },
    {
        path: '/persona-pg/mantenimiento/proveedores',
        name: namesMantenimiento.ROUTE_PROVEEDOR,
        component: () => import('@pages/persona-pg/mantenimiento/Proveedor.vue'),
        meta: {
            title: 'i18n:persona.subopciones.proveedor',
            resource: RESOURCE_PERSONA,
            action: mantenimiento.proveedor,
            breadcrumb: buildBreadcrumb(
                'a:persona.menu_title',
                'a:global.menu.mantenimiento',
                'persona.subopciones.proveedor'
            ),
        },
    },
    {
        path: '/persona-pg/mantenimiento/proveedor/:proveedorId?',
        name: namesMantenimiento.ROUTE_REGISTRAR_PROVEEDOR,
        component: () => import('@pages/persona-pg/mantenimiento/proveedor/RegistrarProveedor.vue'),
        meta: {
            title: 'i18n:persona.subopciones.registro_proveedor',
            resource: RESOURCE_PERSONA,
            action: mantenimiento.registrarProveedor,
            breadcrumb: buildBreadcrumb(
                'a:persona.menu_title',
                'a:global.menu.mantenimiento',
                'persona.subopciones.proveedor',
                'persona.subopciones.registro_proveedor'
            ),
        },
    },

    /**
     * RUTAS DE CONFIGURACION
     */
    {
        path: '/persona-pg/configuracion/permiso-categoria-entidad',
        name: namesConfiguracion.ROUTE_PERMISO_CATEGORIA_ENTIDAD,
        component: () => import('@pages/persona-pg/configuracion/AsignacionPermisoCategoria.vue'),
        meta: {
            title: 'i18n:persona.subopciones.permiso_categoria_entidad',
            resource: RESOURCE_PERSONA,
            action: configuracion.permisoCategoriaEntidad,
            breadcrumb: buildBreadcrumb(
                'a:persona.menu_title',
                'a:global.menu.configuracion',
                'persona.subopciones.permiso_categoria_entidad'
            ),
        },
    },

    /**
     * RUTAS DE TRANSACCIONES
     */
    {
        path: '/persona-pg/transacciones/aprobacion-proveedor',
        name: namesTransacciones.ROUTE_APROBACION_PROVEEDOR,
        component: () => import('@pages/persona-pg/transacciones/AprobacionProveedor.vue'),
        meta: {
            title: 'i18n:persona.subopciones.aprobacion_proveedor',
            resource: RESOURCE_PERSONA,
            action: transacciones.aprobacionProveedor,
            breadcrumb: buildBreadcrumb(
                'a:persona.menu_title',
                'a:global.menu.transacciones',
                'persona.subopciones.aprobacion_proveedor'
            ),
        },
    },

    /**
     * RUTAS DE INFORMES
     */
    {
        path: '/persona-pg/informes/proveedores-cuenta-contable',
        name: namesInformes.ROUTE_INFORME_CCONT_PROVEEDOR_ESTAB,
        component: () => import('@pages/persona-pg/informes/ReporteProveedoresPorEstablecimiento.vue'),
        meta: {
            title: 'i18n:persona.subopciones.proveedor_por_establecimiento',
            resource: RESOURCE_PERSONA,
            action: informes.informeProveedorPorCuenta,
            breadcrumb: buildBreadcrumb(
                'a:persona.menu_title',
                'a:global.menu.informes',
                'persona.subopciones.proveedor_por_establecimiento'
            ),
        },
    },
])
